
import { useContext } from 'react';
import authSessionContext from './context'

const useAuthSession = () => useContext(authSessionContext);
export default useAuthSession;
